import React, { useEffect, useState } from "react";
import TrashIcon from "assets/icon/TrashIcon";
import { ApiResponseStatusUnauthorized, ApiResponseSuccess, DropdownStatusList, EmptyString, FormTypeAdd, FormTypeEdit, PageSize, PageSizeOptions, PaginationBack, PaginationFirst, PaginationLast, PaginationNext, StatusCodeActive, StatusCodeDelete } from "utils/Constant";
import { ApiDeleteTransferSource, ApiGetBankList, ApiGetTransferSourceList } from "utils/constants/api";
import useFetch from "utils/hooks/useFetch";
import FailModal from "components/modal/FailModal";
import LoadingModal from "components/modal/LoadingModal";
import SuccessModal from "components/modal/SuccessModal";
import ConfirmationModal from "components/modal/ConfirmationModal";
import PaginationButton from "components/Input/PaginationButton";
import SearchButton from "components/Button/SearchButton";
import Dropdown from "components/Input/Dropdown";
import { GetStatus } from "utils/helpers";
import RevisionIcon from "assets/icon/RevisionIcon";
import FilterIcon from "assets/icon/FilterIcon";
import XIcon from "assets/icon/XIcon";
import EditIcon from "assets/icon/EditIcon";
import Select from 'react-select'
import AddButton from "components/Button/AddButton";
import TransferSourceFormModal from "./TransferSourceFormModal";
import { useModal } from "utils/context/ModalContext";
import { MainBodyCard, PagesTitle } from "components/Cards";
import { useVariable } from "utils/context/VariableContext";

export default function TransferSource(){
    const { locationId } = useVariable
    const { showFail, showLoading, hideLoading, showSuccess, confirm } = useModal()
    const { data: transferSourceList, fetch: apiGetTransferSourceList } = useFetch(ApiGetTransferSourceList)
    const { fetch: apiDeleteTransferSource } = useFetch(ApiDeleteTransferSource)
    const { fetch: apiGetBankList } = useFetch(ApiGetBankList)

    // Filter
    const [bankId, setBankId] = useState(EmptyString)
    const [bankOptions, setBankOptions] = useState([])
    const [sourceName, setSourceName] = useState(EmptyString)
    const [edcOptions, setEdcOptions] = useState([])
    const [status, setStatus] = useState(DropdownStatusList[1].value)
    const [pageSize, setPageSize] = useState(PageSizeOptions[0].value)
    const [isFilterOpen, setIsFilterOpen] = useState(false)
    const [isToggled, setIsToggled] = useState(false)

    const statusChange = (e) => {setStatus(e.value)}
    const pageSizeChange = (e) => {
        setPageSize(e.value)
    }
    const filterBtnClick = () => {
        setIsFilterOpen(!isFilterOpen)
    } 

    // Grid
    const[paginationOptions, setPaginationOptions] = useState([])
    const[pageIndex, setPageIndex] = useState("")
    const[totalPageCount, setTotalPageCount] = useState(0)

    // Modal
    const [failModal, setFailModal] = useState({ isOpen: false, data: {}, message: EmptyString })
	const [loading, setLoading] = useState({isOpen: false})
    const [successModal, setSuccessModal] = useState({ isOpen: false, data: {} })
    const [confirmationModal, setConfirmationModal] = useState({ isOpen: false, data: {} })
    const [transferSourceFormModal, setTransferSourceFormModal] = useState({ isOpen: false, transactionId: 0, formType: FormTypeEdit, data: {} })

    // Function Api Call
    const getTransactionSource = async (index, pageSize) => {
        let res

        await apiGetTransferSourceList({
            data: {
                bankId: (bankId !== "0" && bankId !== "") ? bankId.value : EmptyString,
                sourceName: sourceName,
                status: status,
                pageSize: pageSize,
                pageIndex: index
            }
        }).then((response) => {
            if(response.status === ApiResponseSuccess){
                res = response
            }else if(response.status === ApiResponseStatusUnauthorized){
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                            window.location.href = "/login"
                        }
                    },
                    message: response.message
                })
            }else{
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                        }
                    },
                    message: response.message
                })
            }
        })

        return res
    }
    const deleteTransferSource = async (id, status) => {
        await apiDeleteTransferSource({
            data: {
                transferSourceId: id,
                status: status
            }
        }).then((response) => {
            if(response.status === ApiResponseSuccess){
                setSuccessModal({ 
                    isOpen: true, 
                    data: { 
                        onSuccess: async () => { 
                            setSuccessModal({isOpen: false})
                        }
                    } 
                })
            }else if(response.status === ApiResponseStatusUnauthorized){
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                            window.location.href = "/login"
                        }
                    },
                    message: response.message
                })
            }else{
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                        }
                    },
                    message: response.message
                })
            }
        })
    }
    const getBankList = async () => {
        await apiGetBankList({
            data: {
                bankCode: EmptyString,
                bankName: EmptyString, 
                status: StatusCodeActive,
                pageSize: 1000,
                pageIndex: 0
            }
        }).then((response) => {
            if(response.status === ApiResponseSuccess){
                if (response.data.listData.length > 0){
                    let data = response.data.listData
                    let tempArray = []

                    tempArray.push({ label: "Select Bank", value: "0" })

                    for (let i = 0; i < data.length; i++){
                        tempArray.push({ label: data[i].bankCode.toUpperCase() + " - " + data[i].bankName.toUpperCase(), value: String(data[i].bankId) })
                    }

                    setBankOptions(tempArray)
                    setBankId(tempArray[0].value)
                }
            }else if(response.status === ApiResponseStatusUnauthorized){
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                            window.location.href = "/login"
                        }
                    },
                    message: response.message
                })
            }else{
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                        }
                    },
                    message: response.message
                })
            }
        })
    }

    // Function Grid
    async function fBindGrid(index, pageSize){
        setLoading({isOpen: true})

        let i = index !== null ? (index !== "" ? parseInt(index) : 0) : 0

        getTransactionSource(i, pageSize).then((res) => {
            if (res !== null && typeof res !== 'undefined'){
                let totalData = res.data.totalData
                fSetPaginationOptions(totalData, index)
                // fGetEdcList().then(() => {
                    setLoading({isOpen: false})
                // })
            }else{
                setEdcOptions([])
                setLoading({isOpen: false})
            }
        })
    }
    function fSetPaginationOptions(dataCount, index){
        let numberOfPage = parseInt(parseInt(dataCount)/PageSize)
        let array = []
        
        setTotalPageCount(numberOfPage = 0 ? 1 : numberOfPage)

        for (let i = 0; i <= numberOfPage; i++){
            array.push({
                label: String(i + 1),
                value: String(i)
            })
        }
        
        setPaginationOptions(array)
        
        if(index !== "" && index !== null){
            setPageIndex(String(index))
        }else{
            setPageIndex("0")
        }
    }
    function fPaginationBtnClick(command){
        if(command === PaginationFirst){
            setPageIndex("0")
            fBindGrid(0, pageSize)
        }else if(command === PaginationBack){
            let index = parseInt(pageIndex) - 1

            if(index >= 0){
                setPageIndex(index)
                fBindGrid(index, pageSize)
            }
        }else if(command === PaginationNext){
            let index = parseInt(pageIndex) + 1

            if (totalPageCount >= index){
                setPageIndex(index)
                fBindGrid(index, pageSize)
            }
        }else if(command === PaginationLast){
            let index = totalPageCount

            setPageIndex(index)
            fBindGrid(index, pageSize)
        }
    }
    function fPaginationIndexChange(index){
        setPageIndex(index)
        fBindGrid(index, pageSize)
    }

    const filterEnterKeyPress = (e) => {
		if(e.key === 'Enter'){
			fBindGrid(0, pageSize)
		}
	}
    const searchBtnClick = () => {
        fBindGrid(0, pageSize)
    }
    const editBtnClick = (id) => {
        setTransferSourceFormModal({ isOpen: true, transferSourceId: id, formType: FormTypeEdit })
    }
    const addBtnClick = () => {
        setTransferSourceFormModal({ isOpen: true, transferSourceId: 0, formType: FormTypeAdd })
    }
    const deleteBtnClick = (id, status) => {
        confirm("Are you sure?").then(() => {
            showLoading()

            try {
                deleteTransferSource(id, status).then(() => {
                    fBindGrid(pageIndex, pageSize)
                })
            } finally {
                hideLoading();
            }
        })
    }

    const transferSourceFormModalClose = () => {
        setTransferSourceFormModal({ isOpen: false, transferSourceId: 0 })
        fBindGrid(pageIndex, pageSize)
    }

    useEffect(() => {
        setLoading({isOpen: true})

        getBankList().then(() => {
            fBindGrid(0, pageSize)
        })
    }, [pageSize, isToggled, locationId])

    return(
        <MainBodyCard>
            <PagesTitle title='Transfer Source' />

            <div className="xl:hidden mt-2 flex justify-end">
                <button className="flex gap-2 rounded-md border p-2 bg-black" onClick={filterBtnClick}>
                    {isFilterOpen ? <XIcon className="fill-white w-6" /> : <FilterIcon className="fill-white w-6" />}
                    <span className="text-white">Filter</span>
                </button>
            </div>

            <div className={`${isFilterOpen ? 'flex' : 'hidden'} xl:flex flex-col xl:flex-row gap-5 justify-between mt-5 bg-white sm:bg-transparent sm:p-0 p-3 rounded-md border sm:border-none`}>
                <div className="flex flex-col sm:flex-row gap-2 sm:gap-4 w-full flex-wrap">
                    <div className="flex flex-col gap-2 w-42">
                        <span>Source Name</span>
                        <input className="input" value={sourceName} onChange={(e) => setSourceName(e.target.value)} onKeyDown={filterEnterKeyPress} />
                    </div>
                    <div className="flex flex-col gap-2 w-42">
                        <span>Bank</span>
                        <Select className="w-72" options={bankOptions} value={bankId} onChange={(e) => setBankId(e)} />
                    </div>
                    <div className="flex flex-col gap-2 w-full sm:w-28">
                        <span>Status</span>
                        <Dropdown value={status} options={DropdownStatusList} onChange={statusChange} placeholder={"All"} />
                    </div>
                </div>
                <div>
                    <div className="flex justify-end items-end h-full">
                        <SearchButton onClick={searchBtnClick} />
                    </div>
                </div>
            </div>

            <div className="flex items-center justify-between">
                <div className="flex items-center gap-4 mt-5">
                    <div>
                        <span>Show </span>
                    </div>
                    <div className="w-20">
                        <Dropdown options={PageSizeOptions} value={pageSize} onChange={pageSizeChange} />
                    </div>
                </div>
                <div>
                    <AddButton onClick={addBtnClick} />
                </div>
            </div>
            
            {/* Wide Screen */}
            <div className="mt-5 w-full">                
                <table className="w-full border bg-white text-md font-light mt-4">
                    <thead>
                        <tr className="h-12">
                            <th className="font-semibold w-12">No</th>
                            <th className="font-semibold text-left px-2">Source Name</th>
                            <th className="font-semibold text-left px-2">Bank</th>
                            <th className="font-semibold text-left px-2">Beneficiary Name</th>
                            <th className="font-semibold text-left px-2">Status</th>
                            <th className="font-semibold text-left px-2">Update By</th>
                            <th className="font-semibold sm:w-24">Action</th>
                        </tr>
                    </thead>
                    {transferSourceList?.data?.listData?.length > 0 ? 
                        <tbody className="border">
                            {transferSourceList?.data?.listData?.map((data, i) => {
                                return(
                                    <tr className="my-0 row h-10 border-y hover:bg-slate-100" key={ i }>
                                        <td className="text-center">{ data.rowNumber }</td>
                                        <td className="px-2 hidden sm:table-cell">
                                            <span>{ data.sourceName }</span>
                                        </td>
                                        <td className="px-2">
                                            <span>{ data.bankName }</span>
                                        </td>
                                        <td className="px-2">
                                            <span>{ data.accountName.toUpperCase() + " (" + data.accountNo + ")" }</span>
                                        </td>
                                        <td className="px-2">
                                            <span>{ GetStatus(data.status) }</span>
                                        </td>
                                        <td className="px-2">
                                            <span>{ data.updateBy.toUpperCase() }</span>
                                        </td>
                                        <td className="flex flex-col sm:flex-row justify-center items-center py-2 gap-2 px-2">
                                            <button className={`button flex gap-2 ${ data.status === StatusCodeDelete ? "hidden" : "block" }`} 
                                                onClick={() => editBtnClick(data.transferSourceId)}
                                            >
                                                <EditIcon className="w-4 fill-white" />
                                            </button>
                                            <button className={`button flex gap-2 ${ data.status === StatusCodeDelete ? "hidden" : "block" }`} 
                                                onClick={() => deleteBtnClick(data.transferSourceId, data.status)} 
                                            >
                                                <TrashIcon className="w-4 fill-white" />
                                            </button>
                                            <button className={`button flex gap-2 ${ data.status === StatusCodeActive ? 'hidden' : 'block' }`} 
                                                onClick={() => deleteBtnClick(data.transferSourceId, data.status)} 
                                            >
                                                <RevisionIcon className="w-4 fill-white" />
                                            </button>
                                        </td>
                                    </tr>
                                )
                            })}
                        </tbody>
                    :
                        <tbody>
                            <tr>
                                <td className="text-center" colSpan={12}>
                                    <span>No Transaction Data</span>
                                </td>
                            </tr>
                        </tbody>
                    }
                </table>

                
            </div>

            <PaginationButton btnFirstClick={() => { fPaginationBtnClick(PaginationFirst) }} btnBackClick={() => { fPaginationBtnClick(PaginationBack) }} 
                options={paginationOptions} value={pageIndex} onChange={(e) => { fPaginationIndexChange(e.value) }} btnNextClick={() => { fPaginationBtnClick(PaginationNext) }}
                btnLastClick={() => { fPaginationBtnClick(PaginationLast) }}
            />

            {/* Modal */}
			{failModal.isOpen && ( <FailModal onClose={() => setFailModal({ isOpen: false, data: {}, message: EmptyString })} data={failModal?.data} message={failModal?.message} /> )}
			{loading.isOpen && ( <LoadingModal onClose={() => setLoading({ isOpen: false })} /> )}
            {successModal.isOpen && ( <SuccessModal onClose={() => setSuccessModal({ isOpen: false, data: {} })} data={successModal?.data} /> )}
            {confirmationModal.isOpen && ( 
                <ConfirmationModal 
                    onClose={() => setConfirmationModal({ 
                        isOpen: false, 
                        data: {} 
                    })} 
                    data={confirmationModal?.data} 
                /> 
            )}
            {transferSourceFormModal.isOpen && ( 
                <TransferSourceFormModal 
                    isOpen={transferSourceFormModal?.isOpen} 
                    onClose={transferSourceFormModalClose} 
                    data={transferSourceFormModal?.data} 
                    transferSourceId={transferSourceFormModal?.transferSourceId} 
                    formType={transferSourceFormModal?.formType} 
                /> 
            )}
        </MainBodyCard>
    )
}